import { fetchConfig } from '@utils';

class ProductForm extends HTMLElement {
  form = this.querySelector('form');
  cartNotification = document.querySelector('cart-notification');
  cartDrawer = document.querySelector('cart-drawer');

  connectedCallback() {
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  async onSubmitHandler(evt, submitButtonEl) {
    evt.preventDefault();

    // Create an array of submit buttons
    const submitButtons = [];

    // Add the submit button of the current product form to the array
    submitButtons.push(this.querySelector('[type="submit"]'));

    // Add any additional submit buttons to the submitButtons array
    // This is used for the floating add to cart button and it can be extended to other buttons in the future
    if (submitButtonEl) {
      submitButtons.push(submitButtonEl);
    }

    submitButtons.forEach((submitButton) => {
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');
    });

    try {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      let sectionsToFetch = [
        ...this.cartNotification.getSectionsToRender().map((section) => section.id),
      ];
      if (this.cartDrawer) {
        sectionsToFetch = [
          ...sectionsToFetch,
          ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ];
      }

      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      // Post the data to the cart add endpoint
      const response = await fetch(`${routes.cart_add_url}`, config);

      // Let's check if the response is okidokey
      if (!response.ok) throw new Error('Network response was not ok');

      // Get json response
      const parsedState = await response.json();
      // Show the error message if the response is not ok because of the inventory quantity
      if (response.status === 422) {
        this.cartNotification.setActiveElement(document.activeElement);
        this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
        return;
      }

      if (this.cartDrawer) {
        this.cartDrawer.renderContents(parsedState);
      }

      // Trigger the interface follow up based on theme settings
      const rebuyPresent = !!window.Rebuy?.SmartCart;

      if (!window.rebuyOverwrite || !rebuyPresent) {
        switch (submitButtons[0].dataset.addToCartBehavior) {
          case 'open_cart_drawer':
            if (this.cartDrawer) {
              this.cartDrawer.open();
            } else if (!Shopify.designMode) {
              window.location.reload();
            }
            break;
          case 'show_cart_notification':
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderContents(parsedState);
            break;
        }
      }

      // Let the chat bot know that the cart has been updated
      if ('Zowie' in window) {
        window.Zowie.updateCart();
      }
    } catch (error) {
      console.error(error);
    }

    submitButtons.forEach((submitButton) => {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    });
  }
}

customElements.define('product-form', ProductForm);
